<script setup lang="ts">
import Icon from './Icon.vue';
withDefaults(defineProps<{ label: string; value: string; icon: string; tone?: string }>(), { tone: 'blue' });
</script>

<template>
  <article class="analytics-metric" :class="`tone-${tone}`">
    <span class="metric-label"><Icon :name="icon" :size="19" /><span>{{ label }}</span></span>
    <strong>{{ value }}</strong>
  </article>
</template>

<style scoped>
.analytics-metric { --metric-color: 70, 139, 225; min-width: 0; padding: 20px; border: 1px solid rgba(var(--metric-color), .16); border-radius: 20px; background: linear-gradient(135deg, rgba(var(--metric-color), .10), rgba(255, 255, 255, .78)); display: grid; align-content: start; gap: 14px; }
.tone-purple { --metric-color: 137, 100, 218; }
.tone-green { --metric-color: 40, 158, 127; }
.tone-amber { --metric-color: 199, 145, 42; }
.tone-rose { --metric-color: 208, 104, 139; }
.metric-label { display: flex; align-items: center; gap: 9px; font-size: 13px; line-height: 1.5; }
.metric-label :deep(svg) { color: rgb(var(--metric-color)); }
strong { font-size: 25px; overflow-wrap: anywhere; }
@media (max-width: 580px) { .analytics-metric { padding: 16px; } }
</style>
